// File: frontend/src/components/matches/MatchList.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import "./MatchList.css";
import { MatchModel } from "../../models";
import { MatchRow } from "./MatchRow";
// Sitewide pins: badge wrapper for the admin-pinned topic row
import { PinnedTopicWrap } from "../common/PinnedTopicWrap";

interface MatchListProps {
  matches: MatchModel[];
  // Must be a stable (useCallback-wrapped) reference from App.tsx.
  // MatchRow is memoized — an unstable prop here defeats the memo entirely.
  onSelectMatch: (matchId: number) => void;
  selectedMatchId: number | null;
  // ID of the admin-pinned match (null = nothing pinned)
  pinnedMatchId?: number | null;
}

export const MatchList: React.FC<MatchListProps> = ({
  matches,
  onSelectMatch,
  selectedMatchId,
  pinnedMatchId = null,
}) => {
  const { t } = useTranslation();

  if (!matches || matches.length === 0) {
    return (
      <div className="no-matches">
        <p>{t("no_match_selected_message")}</p>
      </div>
    );
  }

  return (
    <div className="match-list">
      {matches.map((match) => (
        <PinnedTopicWrap key={match.id} pinned={match.id === pinnedMatchId}>
          <MatchRow
            match={match}
            // Pass the stable callback directly — no per-row lambda wrapper.
            // MatchRow calls onSelectMatch(match.id) itself.
            onSelectMatch={onSelectMatch}
            isSelected={match.id === selectedMatchId}
          />
        </PinnedTopicWrap>
      ))}
    </div>
  );
};